import { useCallback, useEffect } from "react";
import { connect } from "react-redux";

// import { authProvider } from "../../models/auth";

const MrLogin = ({ authenticate }) => {
  const postProcess = useCallback(async (accessToken, refreshToken) => {
    const msg = { type: "session", accessToken, refreshToken };

    try {
      window[
        window.location === window.parent.location ? "opener" : "parent"
      ].postMessage(msg);
    } catch (err) {
      console.error(err);
    }

    try {
      window.clickMobileApp.postMessage(msg);
    } catch (err) {
      console.error(err);
    }

    // await new Promise((r) => setTimeout(r, 100));
    window.close();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const accessToken = searchParams.get("access_token");
    const refreshToken = searchParams.get("refresh_token");

    // authProvider.login({ accessToken, refreshToken });

    postProcess(accessToken, refreshToken);
  }, [postProcess]);
  return null;
};

const mapDispatch = ({ auth: { authenticate } }) => ({ authenticate });

export default connect(null, mapDispatch)(MrLogin);
